export default __webpack_public_path__ + "static/B0247-24d45acd0acbf9962e4a0f3cea40fea9.png";